<template>
  <div>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <h3>Store Purchase History</h3>
        <span class="description">View the members complete direct store purchase history.<br/></span>
      </el-col>
      <!-- <el-col :span="8" class="d-flex flex-justify-end">
        <el-button type="default" @click="$router.push({
          name: 'managements',
          params: {
            selectedTab: 'membermgmt'
          }
        })"
          >Close</el-button
        >
      </el-col> -->
    </el-row>
    <el-divider></el-divider>
    <div class="table-container">
      <i class="header-toggle-icon" :class="{'el-icon-arrow-left': !showFullActions, 'el-icon-arrow-right': showFullActions}" :style="{'right': `1px`}" @click="toggleVisibility"></i>
    <el-table
      :pagination-props="{

        pageSizes: [20, 50, 100],
      }"
      :data="items"
      stripe
      class="mt-1"
      style="width: 100%"
      height="550px"
      :key="regoKey"
    >
      <el-table-column prop="name" label="Item Name" width="200"  :formatter="(r, c, v)=>capitalize(v)" fixed />
      <el-table-column prop="_id" label="Item ID" sortable width="130" />
      <el-table-column prop="price" label="Price" sortable width="130">
        <template slot-scope="scope">
          {{ priceFormatter(scope.row.price) }}
        </template>
      </el-table-column>
      <el-table-column prop="size" label="Size" sortable width="130" />
      <el-table-column prop="qty" label="Quantity" sortable width="130" />
      <el-table-column prop="pinCharge.createdAt" label="Date Purchased" sortable width="150" :formatter="dateFormatter" />
      <!-- <el-table-column
        prop="entityType"
        label="Entity Type"
        min-width="140"
        :formatter="(r, c, v)=>capitalize(v)"
        column-key="entityType"
        :filters="[
          { text: 'Membership', value: 'membership' },
          { text: 'Event', value: 'event' }
        ]"
        :filter-method="filterEntityType"
        filter-placement="bottom-end">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.entityType === 'membership' ? 'primary' : 'success'"
            disable-transitions>
            {{ capitalize(scope.row.entityType) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="productType" label="Product Type" sortable min-width="150" :formatter="(r, c, v)=>formatProductType(v)"/>
      <el-table-column prop="team.name" label="Team" sortable min-width="120"/>
      <el-table-column prop="memberType" label="Member Type" sortable min-width="140" :formatter="(r, c, v)=>capitalize(v)"/>
      <el-table-column prop="tags" label="Tags" width="200" sortable :formatter="(r,c,v)=> joinTag(v)"></el-table-column>
      <el-table-column prop="orgtree.club.name" label="Club" sortable min-width="120"/>
      <el-table-column prop="orgtree.association.name" label="Association" sortable min-width="150"/>
      <el-table-column prop="season" label="Season" sortable min-width="100" />
      <el-table-column label="Expiry Date" min-width="220" :formatter="dateFormatter">
        <template slot-scope="props">
          <div v-if="editingRowId !== props.row._id">
            <div v-if="props.row.expiry" class="">
              <span>
                {{ dateFormatter(false, false, props.row.expiry) }}

              </span>
              <el-button
              v-if="expiryDateEditable && isEditable(props.row)"
                          type="text"
                          icon="el-icon-edit"

                          @click="startEditing(props.row)"
                          >Edit</el-button
                        >
            </div>
            <div v-else>
              No Expiry Date
            </div>
          </div>
          <div v-else class="d-flex align-items-center">
            <el-date-picker
              v-model="props.row.expiry"
              type="date"
              placeholder="Pick a day"
              >
            </el-date-picker>
            <el-button
              type="text"
              icon="el-icon-check"
              @click="finishEditing(props.row)"
              class="ml-2 success-text"
              ></el-button>
            <el-button
              type="text"
              icon="el-icon-close"
              class="danger-text"
              @click="cancelEditing(props.row)"
              ></el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="expired"
        label="Expired"
        :formatter="(r, c, v)=> getExpiry(r)"
        min-width="100"
        column-key="expired"
        :filters="[
          { text: 'Yes', value: true },
          { text: 'No', value: false }
        ]"
        :filter-method="filterExpired"
        filter-placement="bottom-end" />
        <el-table-column label="Pay After" width="150">
        <template v-slot="scope">
          <span>
            {{ (scope.row.payAfter || scope.row.payLater) ? 'Yes' : 'No' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Paid" width="150">
        <template v-slot="scope">
          <span v-if="(scope.row.payAfter || scope.row.payLater)">
            {{ getAmountPaid(scope.row) }}
          </span>
          <span v-else>
            <span v-if="get(scope.row, 'meta.paid') === false">No</span>
            <span v-else>Yes</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="Outstanding" width="130">
        <template v-slot="scope">
          <span>
            {{ getAmountRemaining(scope.row) }}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="deregistered" label="Deregistered" sortable min-width="140" :formatter="(r, c, v)=> v ? 'Yes' : 'No' " />
      <el-table-column prop="refunded" label="Refunded" sortable min-width="140">
        <template slot-scope="props">
          <div>
            <el-tag type="success" v-if="isRefunded(props.row)">Yes</el-tag>
            <el-tag type="danger" v-else>No</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="refundAmount" label="Refund Amount" sortable min-width="150">
        <template slot-scope="props">
          <div>
            <span v-if="isRefunded(props.row)">{{ getRefundAmount(props.row) }}</span>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" :label="getDatePurchasedLabel" sortable min-width="150" :formatter="dayDateFormatter" />
      <el-table-column prop="isManual" label="Manual Add" min-width="130" sortable :formatter="(r, c, v)=> v ? 'Yes' : 'No' "/>
      <el-table-column
        label="Renewed"
        min-width="120"
        sortable
        :formatter="(r, c, v)=> r.meta?.isRenewed ? 'Yes' : r.isRenewed ? 'Yes' : '' "
      />
      <el-table-column label="Result" min-width="180">
        <template slot-scope="props">
          <div class="result-capture" v-if="Object.keys(props.row.results).length" >
            <div>{{ props.row.results.name }}</div>
            <div class="font-light">{{ props.row.results.value }} ({{ getResultLabel(props.row.results.type) }})</div>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column
      :min-width="130"
      fixed="right"
      align="center"
      class="actions-column"
      :class="{ 'closed': !showFullActions }">
        <div slot="header">
          <div >Actions
            <!-- info icon -->
            <el-tooltip placement="top">
              <div slot="content">
                <span>Only registrations under selected role are editable.</span>
              </div>
              <i class="el-icon-info"></i>
            </el-tooltip>
          </div>
        </div>

        <!-- Row Template -->
        <template slot-scope="scope">
          <div class="row-container">
            <!-- <div class="read-only-badge" v-if="!isEditable(scope.row)">Read Only</div> -->
            <!-- Expanded Mode: All Buttons Displayed -->
            <div class="d-flex flex-justify-center">
              <el-tooltip placement="top" >
                <div slot="content">
                  <span>Refund</span>
                </div>
                <el-button
                @click.prevent="initiateRefund(scope.row)"
                type="primary"
                size="mini"
                v-if="isEditable(scope.row)"
                >
                <fa-icon :icon="['fal', 'money-from-bracket']"/>
                </el-button>
              </el-tooltip>
              <!-- button to edit offline payment -->
              <!-- <el-tooltip placement="top" v-if=" isEditable(scope.row)">
                <div slot="content">
                  <span>View Payment Details</span>
                </div>
                <el-button type="primary" size="small" @click="editOfflinePayment(scope.row)">
                  <i class="el-icon-edit"></i>
                </el-button>
              </el-tooltip> -->
              <el-tooltip placement="top">
                <div slot="content">
                  <span>Receipt</span>
                </div>
                <el-button type="primary"
                size="mini"
                v-if="isEditable(scope.row)"
                  @click="downloadReceipt(scope.row)"
                >
                <fa-icon :icon="['fal', 'receipt']"/>
                </el-button>
              </el-tooltip>
            </div>
          </div>

        </template>
      </el-table-column>
    </el-table>
  </div>

    <el-dialog
    :title="`Refund - Registration ${refundRow._id}`"
    :visible="refundModalVisible"
    width="85%"
    @close="charges = []; refundRow = false; refundModalVisible = false; editingRowId = undefined">
      <el-alert
        title="Refund Eligibility"
        type="info"
        description="Registrations with multi-level disbursement are not eligible for refund. If you can see a charge but the refundable amount displays $0, it means the money has already been transferred to the account holder and is no longer refundable."
        show-icon
        :closable="false">
      </el-alert>
      <!-- el divider with title -->
      <el-divider >
        <span>Transaction History</span>
      </el-divider>
      <el-table
      v-if="refundModalVisible"
      :pagination-props="{
        pageSizes: [20, 50, 100],
      }"
      v-loading="refundLoading"
      :data="charges"
      stripe
      class="mt-1"
      style="width: 100%"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <template>
            <div v-for="(refund, idx) in props.row.refunds" :key="`refund-${idx}`" :style="{ padding: '0 2rem' }">
              <p>Refund ID: {{ refund._id }}</p>
              <p>Date Submitted: {{ dateFormatter(false, false, refund.createdAt) }}</p>
              <p>Amount: {{ priceFormatter(refund.amount) }}</p>
              <p>Status: <b :class="refundStatusClass(refund.status)">{{ capitalize(refund.status) }}</b></p>
              <p v-if="refund.status === 'failed'">Pin Error: {{ get(refund, 'attemptHistory[0].errorMessage.data.messages[0].message') }}</p>
              <p v-if="refund.status !== 'failed'">Earliest Disburse: {{ earliestProcess(refund.createdAt) }}</p>
              <hr/>
            </div>
          </template>
          <template v-if="!props.row.refunds || !props.row.refunds.length">
            <div>
               {{ props.row.type === 'offline' ? get(props.row, 'note', 'Payment was made offline') : 'No Refund Found For This Charge' }}
            </div>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="_id" label="ID" width="60" />
      <el-table-column prop="createdAt" label="Payment Date" :formatter="dateFormatter" />
      <el-table-column prop="amount" label="Amount Paid (Excl. Tx Fees)">
        <template slot-scope="scope">
          {{ scope.row.type === 'offline' ? parsePrice(scope.row.amount) : amountPaid(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="refunds" label="Amount Refunded">
        <template slot-scope="scope">
          {{ scope.row.type === 'offline' ? 'Offline' : amountRefunded(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="refunds" label="Amount Refundable">
        <template slot-scope="scope">
          {{ scope.row.type === 'offline' ? 'Offline' : priceFormatterDollar(amountRefundable(scope.row)) }}
        </template>
      </el-table-column>
      <el-table-column label="Partial Allowed" min-width="100">
        <template slot-scope="scope">
          <el-tag
            v-if="partialAllowed(scope.row)"
            type="success"
          >Yes</el-tag>
          <el-tag
            v-else
            type="danger"
          >No</el-tag>
        </template>
      </el-table-column>
      <el-table-column
      width="350"
      label="Refund"
      fixed="right">
        <template slot-scope="scope">
          <div class="d-flex">
            <el-input-number :disabled="scope.row.type === 'offline'" v-model="scope.row.refundAmount" :min="partialAllowed(scope.row) ? 0 : amountRefundable(scope.row)" :controls="false" :precision="2" :step="0.01" :max="amountRefundable(scope.row)"></el-input-number>
            <el-button
            class="ml-2"
            @click.prevent="submitRefund(scope.row)"
            :disabled="amountRefundable(scope.row) <= 0 || scope.row.nonRefundable || scope.row.type === 'offline'"
            type="primary"
            >
              Refund
            </el-button>
          </div>
        </template>
      </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
    v-if="refundRow"
    :title="`Payment Adjustment - Member ${member.profile.firstName} ${member.profile.lastName}`"
    :visible="offlinePaymentModalVisible"
    width="85%"
    @close="offlinePaymentModalVisible = false; editingRowId = undefined; payments = []; charges = []; refundRow = false">
    <div class="d-flex flex-column flex-justify-end flex-align-end" >
      <div class="d-flex flex-justify-end gap-1" >
          <!-- button for add offline refund -->
          <el-button type="secondary" @click="addManualRefundModalVisible = true" :disabled="allowOfflinePayment === false">
            Add Offline Refund
          </el-button>
          <el-button type="primary" @click="addManualPaymentModalVisible = true" :disabled="allowOfflinePayment === false">
            Add Offline Payment
          </el-button>
          <!-- add a exclamation icon to tell user this is not allowed, please enable it in national settings-->
          <el-tooltip placement="top" v-if="allowOfflinePayment === false">
            <div slot="content">
              <span>This is not allowed, please enable it in national settings.</span>
            </div>
            <i class="el-icon-warning"></i>
          </el-tooltip>

      </div>
        <div class="mt-2 d-flex flex-justify-end">
          <el-checkbox v-model="refundRow.isPaid" @change="handleMakePaid()">{{ 'Mark as Paid' }}</el-checkbox>
        </div>
    </div>
    <el-divider>
      <span>Purchase Summary</span>
    </el-divider>
    <el-card>
    <el-card-body class="d-flex justify-between align-items-center">
      <div class="general-info" style="flex: 2; padding-right: 20px;">
        <h4>Purchase Details</h4>
        <div class="detail-item">
          <span class="label">ID:</span> <span class="value">{{ refundRow._id }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Name:</span> <span class="value">{{ get(refundRow, 'regoEntity.name', '') }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Date:</span> <span class="value">{{ dateFormatter(false, false, get(refundRow, 'createdAt')) }}</span>
        </div>
      </div>
      <div class="payment-info" style="flex: 2; padding-left: 20px;">
        <h4>Payment Details</h4>
        <div class="detail-item">
          <span class="label">Total:</span> <span class="value">{{ parsePrice(get(refundRow, `price`, 0) * refundRow.qty) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Offline Paid:</span> <span class="value">{{ parsePrice(getOfflinePaid) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">
            Online Paid
            <el-tooltip placement="top">
              <div slot="content">No transaction fees included</div>
              <i class="el-icon-info "></i>
            </el-tooltip>
            :</span>
          <span class="value">{{ parsePrice(getOnlinePaid())}}</span>
        </div>
        <div class="detail-item">
          <span class="label">Offline Refunded:</span> <span class="value">{{ parsePrice(getOfflineRefunded) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Online Refunded:</span> <span class="value">{{ parsePrice(getOnlineRefunded()) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">Outstanding:</span> <span class="value">{{ parsePrice(getOutstanding) }}</span>
        </div>
      </div>
      <div class="progress-container mt-1">
        <el-progress type="circle" :percentage="getProgress" :stroke-width="10" color="blue"></el-progress>
      </div>
    </el-card-body>
  </el-card>
      <!-- <el-alert
        title="Offline Payment"
        type="info"
        description="This is an offline payment for a registration. The payment is not eligible for refund."
        show-icon
        :closable="false">
      </el-alert> -->
      <!-- el divider with title -->
      <el-divider >
        <span>Transaction Historys</span>
      </el-divider>
      <el-table
      v-if="offlinePaymentModalVisible"
      :pagination-props="{
        pageSizes: [20, 50, 100],
      }"
      v-loading="refundLoading"
      :data="payments"
      stripe
      row-key="createdAt"
      default-expand-all
      :tree-props="{children: 'refunds'}">
      class="mt-1"
      style="width: 100%"
    >
      <el-table-column prop="_id" label="ID" width="100" />
      <el-table-column prop="createdAt" label="Payment Date" :formatter="dateFormatter" />
      <el-table-column prop="amount" label="Amount Paid">
        <template slot-scope="scope">
          {{ parsePrice(scope.row.action === 'payment' ? calculateAmountWithFee(scope.row.amount) : scope.row.amount) }}
        </template>
      </el-table-column>
      <el-table-column label="Method">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.type === 'online' ? 'success' : 'info'"
          >
            {{ scope.row.type === 'online' ? 'Online' : 'Offline' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column  label="Type">
        <template slot-scope="scope">
          {{ scope.row.action === 'payment' ? 'Payment' : 'Refund' }}
        </template>
      </el-table-column>
      <el-table-column
      width="350"
      label="Note"
      fixed="right">
        <template slot-scope="scope">
          {{ scope.row.note }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="120" >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.type !== 'online' && scope.row.action === 'payment'"
            type="danger"
            size="mini"
            @click="deleteOfflinePayment(scope.row)"
          >
            <i class="el-icon-delete"></i>
          </el-button>
        </template>
      </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
    title="Add To Event"
    :visible="addToEventModalOpen"
    width="60%"
    @close="clearModal">
      <el-form>
        <el-row>
          <el-form-item label="Event">
            <el-select v-model="addToEventId" class="mt-2" filterable>
              <el-option
                v-for="e in events"
                :key="e._id"
                :label="e.name"
                :value="e._id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="Product">
            <el-select v-model="addToEventProductId" class="mt-2" filterable>
              <el-option
                v-for="p in products"
                :key="`${p._id}|${p.team && p.team._id}`"
                :label="formatProduct(p)"
                :value="`${p._id}|${p.team && p.team._id}`"
                :disabled="p.registered"
              ></el-option>
              </el-select>

          </el-form-item>
        </el-row>
        <el-row>
          <el-button type="primary" :disabled="!addToEventProduct || !addToEventId" @click="initialAddToEvent">
            Add To Event
          </el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
    title="Add Membership"
    :visible="addToMembershipModalOpen"
    width="60%"
    @close="clearModal">
      <el-form>
        <el-row>
          <el-form-item label="Membership">
            <el-select v-model="addToMembershipId" class="mt-2" filterable>
              <el-option
                v-for="e in memberships"
                :key="e._id"
                :label="filterEntityName(e)"
                :value="e._id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="Product">
            <el-select v-model="addToMembershipProductId" @change="handleMembershipProductChange" class="mt-2" filterable>
              <el-option
                v-for="p in products"
                :key="`${p._id}`"
                :label="formatProduct(p)"
                :value="`${p._id}`"
              ></el-option>
              </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button type="primary" :disabled="!addToMembershipProductId || !addToMembershipId" @click="handleAddToMsClicked">
            Add To Membership
          </el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog
    title="Add Booking"
    :visible="addBookingModalOpen"
    width="60%"
    @close="clearModal">
      <el-form>
        <el-row>
          <el-form-item>
          <div class="filterBy">Filter By:</div>
           <el-radio-group v-model="filters.entityType">
            <el-radio label="event">Event</el-radio>
            <el-radio label="venue">Venue</el-radio>
          </el-radio-group>
          <el-select v-model="filters.entityId" filterable class="mt-2">
            <el-option
              v-for="e in filterEntities"
              :key="e._id"
              :label="filterEntityName(e)"
              :value="e._id"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-row>
          </el-form>
        <el-row v-if="filters.entityType === 'event'">
          <event-product-card
          v-for="product in slotList"
          @update-cart="updateCartEvent"
          :product="product"
          :key="product._id"
          :eventName="product.name || entity.event.name"
          />
            </el-row>
        <el-row>
        <el-row v-if="filters.entityType === 'venue'" >
          <date-picker v-if="filters.entityId" v-model="currentDate"/>
          <venue-schedule :key="key" v-if="filters.entityId" @update-cart="updateCartVenue" :currentDate="currentDate" :venueId="filters.entityId" :slotArr="slotList" class="mt-2"/>
        </el-row >
          <el-row class="mt-2">
            <div class="total-cart" v-if="totalCart > 0">
              <span class="total-header">Total</span>
              <span class="total-price">{{ totalCart | toDollar }}</span>
            </div>
          </el-row>
          <el-button type="primary" :disabled="totalCart === 0" @click="addBooking">
            Add Booking
          </el-button>
        </el-row>
    </el-dialog>
    <!-- el dialog to display qrcode -->
    <el-dialog
      :title="`Qr Code for membership card`"
      :visible.sync="showQrCodeDialog"
      width="30%"
      >
      <div style=" overflow-x: auto; width:100%">
        <div class="d-flex justify-content-center">
          <img :src="qrCode" alt="QR Code" />
        </div>
      </div>
    </el-dialog>
    <el-dialog
    :title="`Membership Required`"
    :visible.sync="requireMsDialog"
    width="50%"
    >
      <div>
        <p class="word-break">You are attempting to assign this member to a product that requires a membership. The following memberships are required:</p>
        <ul>
      <li v-for="name in msRequiredList" :key="name">
        <strong>{{ name }}</strong>
      </li>

    </ul>
    <p class="word-break">If you cannot see one of the required memberships, it might have been set up at a higher hierarchy level. In this instance, please contact your administrator.</p>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button @click="requireMsDialog = false">OK</el-button>
    </span>
    </el-dialog>
    <el-dialog
      :title="`Add Manual Payment`"
      :visible.sync="addManualPaymentModalVisible"
      width="60%"
      @close="clearManualPaymentForm"
      >
      <el-alert
        title="Manual Payment"
        type="info"
        show-icon
        :closable="false"
        :description="'If you receive a payment outside of this platform, you can add it here to keep track of it.'"
      />
      <el-form :model="manualPaymentForm" :rules="manualPaymentRules" ref="manualPaymentForm">
        <el-row class="mt-2" :gutter="20">
          <el-col :span="12">
        <el-form-item label="Amount Paid" prop="amount">
          <el-price-input-v2 type="number" v-model="manualPaymentForm.amount" placeholder="E.g: 10.50" />
        </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Payment Date" prop="date">
            <el-date-picker v-model="manualPaymentForm.date" type="date" placeholder="Select payment date"></el-date-picker>
          </el-form-item>
        </el-col>
        </el-row>
        <!-- note -->
        <el-form-item>
          <el-input type="textarea" v-model="manualPaymentForm.note" placeholder="Enter a note for this payment"></el-input>
        </el-form-item>
        <div class="d-flex flex-justify-end">
        <el-form-item>
          <el-button type="primary" @click="submitManualPayment">Submit</el-button>
          <el-button @click="clearManualPaymentForm">Cancel</el-button>
        </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="`Add Manual Refund`"
      :visible.sync="addManualRefundModalVisible"
      width="60%"
      >
      <el-form :model="manualRefundForm" :rules="manualRefundRules" ref="manualRefundForm">
        <el-row class="mt-2" :gutter="20">
          <el-col :span="12">
        <el-form-item label="Amount Refunded" prop="amount">
          <el-price-input-v2 type="number" v-model="manualRefundForm.amount" placeholder="E.g: 10.50" />
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="Refund Date" prop="date">
          <el-date-picker v-model="manualRefundForm.date" type="date" placeholder="Select refund date"></el-date-picker>
        </el-form-item>
        </el-col>
        </el-row>
        <!-- note -->
        <el-form-item>
          <el-input type="textarea" v-model="manualRefundForm.note" placeholder="Enter a note for this refund"></el-input>
        </el-form-item>
        <div class="d-flex flex-justify-end">
          <el-form-item>
            <el-button type="primary" @click="submitManualRefund">Submit</el-button>
            <el-button @click="clearManualRefundForm">Cancel</el-button>
          </el-form-item>
        </div>
      </el-form>

    </el-dialog>
    <el-dialog
      :title="`Family Membership`"
      :visible.sync="addMembersDialog"
      width="60%"
      >
      <div style=" overflow-x: auto;">
        <el-table
          style="width: 100%"
          :data="familyMSList">
          <el-table-column
            prop="gender"
            label="Gender"
            width="100">
          </el-table-column>
          <el-table-column
            label="Member Type"
            width="120">
            <template v-slot="scope">
              {{ scope.row.memberType | cap }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ageFrom"
            label="Age From"
            width="100">
          </el-table-column>
          <el-table-column
            prop="ageTo"
            label="Age To"
            width="100">
          </el-table-column>
          <el-table-column min-width="200" label="Member">
            <template v-slot="scope">
              <el-select v-model="scope.row.memberId" placeholder="Select Member" :disabled="isRenewing">
                <el-option v-for="e in scope.row.availableMembers" :label="`${e.profile.firstName} ${e.profile.lastName}`" :key="e._id" :value="e._id" />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <div class="member-btn d-flex justify-content-end flex-0 mt-1">
            <el-button @click="cancelFamilyRego" >Cancel</el-button>
            <el-button :disabled="!selectedMember" type="primary" class="" @click="initRegoFamily(familyMSList)">{{ isRenewing ? 'Renew' : 'Register' }}</el-button>
          </div>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      :title="getTitle"
      :visible.sync="clearanceDialogVisible"
      width="60%"
      >
      <div class="d-flex flex-column " v-if="!memberClearanceRequest">
        <span class="break-word">You are already registered to another club as a player, you need to request a clearance to be able to continue.</span>
        <div class="mt-10">
          <el-input-title required >Reason</el-input-title>
          <el-input class="search-box input-field reason" placeholder="Type your reason here" v-model="clearanceRequest.reason" ></el-input>
        </div>
      </div>
      <div class="d-flex flex-column " v-if="memberClearanceRequest && memberClearanceRequest.status ==='Pending'">
        <span class="break-word">Registration clearance has been submmited. Please contact your Club or Association for further information.</span>
      </div>
      <div class="d-flex flex-column w-100" v-if="memberClearanceRequest && memberClearanceRequest.status ==='Declined'">
      <span class="break-word">Registration clearance has been denied. Please contact your Club or  Association for further information.</span>
      <span class="break-word">If you would like to request another clearance, please click Request another clearance button below.</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearanceDialogVisible = false , clearanceRequest.reason= '' ">Cancel</el-button>
        <el-button type="primary" v-if="!memberClearanceRequest " @click="handleRequestClearances">Request Clearance</el-button>
        <el-button type="primary" v-if="memberClearanceRequest && memberClearanceRequest.status ==='Declined'" @click="handleRequestClearances">Request Another Clearance</el-button>
      </span>
    </el-dialog>

    <RenewMembership ref="renewMembership" :rego="selectedRego" v-if="selectedRego" @renewed="renewed" />

  </div>
</template>
<script>
import moment from 'moment';
import _, { startCase, capitalize, get } from 'lodash';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { resultTypes } from '@/utils/constants';
import { calculateMemberAge } from '@/utils/helpers';
import { timedate } from '@/utils/timedate';
import { roles } from '@/utils/roles';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import eventProductCard from './EventProductCard.vue';
import datePicker from './DatePicker.vue';
import venueSchedule from './VenueSchedule.vue';
import RenewMembership from './Renewal.vue';

export default {
  props: ['value', 'member'],
  components: {
    eventProductCard,
    datePicker,
    venueSchedule,
    RenewMembership,
  },
  data() {
    return {
      items: [],
      renewingProduct: undefined,
      isRenewing: false,
      clearanceDialogVisible: false,
      memberClearanceRequest: undefined,
      clearanceRequest: {
        reason: ''
      },
      requireMsDialog: false,
      msRequiredList: [],
      addManualPaymentModalVisible: false,
      offlinePaymentModalVisible: false,
      addManualRefundModalVisible: false,
      manualRefundForm: {
        amount: '',
        date: '',
        note: ''
      },
      payments: [],
      makePaid: false,
      manualPaymentForm: {
        amount: '',
        date: '',
        note: ''
      },
      manualPaymentRules: {
        amount: [
          { required: true, message: 'Please input the amount paid', trigger: 'blur' }
        ],
        date: [
          { required: true, message: 'Please select the payment date', trigger: 'change' }
        ],
        note: [
          { required: false, }
        ]
      },
      manualRefundRules: {
        amount: [
          { required: true, message: 'Please input the amount refunded', trigger: 'blur' }
        ],
        date: [
          { required: true, message: 'Please select the refund date', trigger: 'change' }
        ],
        note: [
          { required: false, }
        ]
      },
      slotList: [],
      addMembersDialog: false,
      familyMSList: [],
      familymembers: [],
      currentDate: moment().valueOf(),
      pickedTicket: undefined,
      roles,
      capitalize,
      get,
      criteria: {
        firstName: undefined,
        lastName: undefined,
        email: undefined
      },
      deregisteringRow: false,
      charges: [],
      refundRow: false,
      refundLoading: false,
      refundModalVisible: false,
      members: [],
      events: [],
      memberships: [],
      venues: [],
      products: [],
      offlineRefunds: [],
      registrations: [],
      regoKey: 0,
      key: 0,
      addToEventId: undefined,
      addToMembershipId: undefined,
      addToEventProductId: undefined,
      addToMembershipProductId: undefined,
      addToEventModalOpen: false,
      addToMembershipModalOpen: false,
      addBookingModalOpen: false,
      editingRowId: undefined,
      filterBy: 'Events',
      availbleList: [],
      filterEntityId: undefined,
      filters: {
        isActive: true,
        entityType: 'event',
        entityId: undefined,
        fieldId: undefined,
        dateRange: undefined,
      },
      productList: [],
      cart: [],
      showQrCodeDialog: false,
      qrCode: '',
      showFullActions: false, // Initially hide full actions
      msCard: undefined,
      selectedRego: undefined,
    };
  },
  async mounted() {
    this.registrations = _.cloneDeep(this.value);
    this.$store.commit('loading', true);
    try {
      Promise.all([
        this.$http.get('/assemble/api/v1/admin/events'),
        this.$http.get('/assemble/api/v1/admin/memberships/all-upper-levels'),
        this.$http.get('/assemble/api/v1/admin/venues')])
        .then(([eventData, membershipData, venueData]) => {
          this.$set(this, 'events', eventData.data.data);
          this.$set(this, 'memberships', membershipData.data.data);
          this.$set(this, 'venues', venueData.data.data);
          this.$store.commit('loading', false);
        });
    } catch (e) {
      this.$message.error(_.get(e, 'response.data.message', 'Unable to pull data at the moment'));
    }

    if (this.member._id) {
      this.$store.commit('loading', true);
      this.$http.get(`/assemble/api/v1/admin/registrations/members/${this.member._id}/store-purchase-history`)
        .then((res) => {
          // console.log({
          //   res
          // });
          const storePurchaseHistory = _.get(res, 'data.data', []);
          // eslint-disable-next-line no-restricted-syntax
          for (const storePurchase of storePurchaseHistory) {
            // console.log({
            //   storePurchase
            // });
            const purchaseItems = _.get(storePurchase, 'items', []);
            // console.log({
            //   purchaseItems
            // });
            const items = _.map(purchaseItems, (item) => ({
              ...item,
              entityType: storePurchase.entityType,
              saleableItem: item,
              purchase: storePurchase,
              pinCharge: _.get(storePurchase, 'pinCharge', {}),
            }));
            this.items = [...this.items, ...items];
          }
          // console.log({
          //   items: this.items
          // });
          this.$store.commit('loading', false);
        })
        .catch((e) => {
          this.$message.error(e);
          this.$store.commit('loading', false);
        });
    }
  },
  computed: {
    activeRole() {
      return this.$store.getters['user/activeRole'];
    },
    isEditable() {
      return (registration) => {
        const { orgtree } = registration;
        return (
          (orgtree.club?._id === this.activeRole.entity._id && this.activeRole.type === 5)
          || (orgtree.association?._id === this.activeRole.entity._id && this.activeRole.type === 4)
          || this.activeRole.type === 3
          || this.activeRole.type === 2
        );
      };
    },
    getTitle() {
      return this.memberClearanceRequest
        ? 'Registration Unavailable'
        : 'Registration Clearance Request';
    },
    getMinWidth() {
      // check all registrations, if any of them have entityType === 'membership', return 320, otherwise return 200
      const hasMembership = this.registrations.some((r) => r.entityType === 'membership');
      return hasMembership ? 400 : 220;
    },
    getOfflinePaid() {
      const offlinePayments = this.payments.filter((payment) => payment.type !== 'online' && payment.action === 'payment');
      if (!offlinePayments.length) return 0;
      return offlinePayments.reduce((acc, current) => acc + current.amount, 0);
    },
    getOfflineRefunded() {
      const offlineRefunds = this.payments.filter((refund) => refund.type !== 'online' && refund.action === 'refund');
      if (!offlineRefunds.length) return 0;
      return offlineRefunds.reduce((acc, current) => acc + current.amount, 0);
    },
    getOutstanding() {
      // if (!this.refundRow) return 0;
      // const { pricing, entityType, meta } = this.refundRow;
      // if (meta?.paid === true) {
      //   return 0;
      // }
      // return pricing[entityType].total - pricing[entityType].totalDiscounts - this.getOfflinePaid - this.getOnlinePaid() > 0 ? pricing[entityType].total - this.getOfflinePaid - this.getOnlinePaid() : 0;
      return '';
    },
    allowOfflinePayment() {
      return this.$store.getters['national/allowOfflinePayment'];
    },
    getProgress() {
      const { refundRow, payments } = this;
      const { price } = refundRow.purchase;
      // console.log({
      //   price,
      //   payments,
      //   refundRow,
      // });
      const platformPayments = payments && payments.length ? payments.reduce((acc, current) => acc + current.amount, 0) : 0;
      if (platformPayments >= price) return 100;
      if (refundRow.isPaid) {
        return 100;
      }
      // eslint-disable-next-line no-nested-ternary
      const per = platformPayments > 0 && price > 0 ? (platformPayments / price) * 100 : price > 0 ? 0 : 100;
      return per.toFixed(2);
    },
    selectedMember() {
      const hasSelected = _.every(this.familyMSList, (fm) => fm.memberId !== undefined);

      return hasSelected;
    },
    manualAddEnabled() {
      const { clearance } = this;
      const addToEventSettings = this.$store.getters['national/addToEventSettings'];
      if (!addToEventSettings) return true;

      const settings = addToEventSettings.find((setting) => setting.level === clearance);
      if (settings) return settings.value;

      return true;
    },
    expiryDateEditable() {
      const { clearance } = this;
      const expiryDateSettings = this.$store.getters['national/expiryDateSettings'];
      if (!expiryDateSettings) return true;

      const settings = expiryDateSettings.find((setting) => setting.level === clearance);
      if (settings) return settings.value;
      return true;
    },
    totalCart() {
      return this.cart.reduce((acc, item) => acc + item.product.price * item.quantity, 0);
    },
    filterEntities() {
      if (this.filters.entityType === 'event') {
        return this.events;
      }
      return this.venues;
    },
    getResultLabel: () => (type) => (_.find(resultTypes, { type }) ? _.find(resultTypes, { type }).label : ''),
    addToEventProduct() {
      const { addToEventProductId, products } = this;
      if (!addToEventProductId) return false;
      const [_id, teamId] = addToEventProductId.split('|');
      const found = products.find((p) => p._id === _id);
      if (found && found.productType !== 'indv-to-team') return found;
      if (found && found.productType === 'indv-to-team') {
        const teamFound = teamId && products.find((p) => p._id === _id && p.team._id === +teamId);
        if (teamFound) return teamFound;
      }
      return false;
    },
    addToMembershipProduct() {
      const { addToMembershipProductId, products } = this;
      if (!addToMembershipProductId) return false;
      const _id = addToMembershipProductId;
      console.log('id', _id);
      const found = products.find((p) => p._id === _id);
      console.log('found prodyct', found);
      if (found && (found.productType === 'indv' || found.productType === 'family')) return found;
      return false;
    },
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    logo() {
      const logo = process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '' ? process.env.VUE_APP_LOGO : require('@/assets/logos/Assemble_Logo_RGB_Positive.png');
      const logoMark = process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Positive.png');
      return logo || logoMark;
    },
    getDatePurchasedLabel() {
      return +process.env.VUE_APP_NATIONAL_ID === 8 ? 'Registration Date' : 'Date Purchased';
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    },
  },
  methods: {
    deleteOfflinePayment(payment) {
      this.$confirm('Are you sure you want to delete this offline payment?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
      // Different endpoints for different registration types
        const endpoint = `/assemble/api/v1/admin/registrations/${this.refundRow._id}/offline-payment/${payment.createdAt}`;

        this.$http.delete(endpoint)
          .then(() => {
            const index = this.payments.findIndex((p) => p.createdAt === payment.createdAt);
            this.payments.splice(index, 1);

            this.$message({
              type: 'success',
              message: 'Offline payment deleted successfully'
            });
          })
          .catch((error) => {
            this.$message.error(error.response?.data?.message || 'Failed to delete payment');
          });
      }).catch(() => {
      // Handle cancel
      });
    },
    calculateAmountWithFee(amount) {
      const feePercentage = this.transactionFee();
      return amount * (1 + feePercentage / 100);
    },
    handleMembershipProductChange() {
    },
    getAmountPaid(row) {
      if (row.payAfter) {
        if (row.payAfterMeta.fullyPaid) {
          return ' Paid';
        }
        // else return amount paid/ amount paid + amount remaining
        return `$${(row.payAfterMeta.amountPaid / 100).toFixed(2)} / $${((row.payAfterMeta.amountPaid + row.payAfterMeta.amountRemaining) / 100).toFixed(2)}`;
      }
      if (row.payLater) {
        if (row.isPaid) {
          return 'Paid';
        }
        if (row.offlinePayments && row.offlinePayments.length) {
          // reduce the offline payments by transaction fee
          const amountPaid = row.offlinePayments.reduce((acc, current) => acc + (current.amount), 0);
          return `$${(amountPaid / 100).toFixed(2)}`;
        }
        return '$0';
      }
      return '$0';
    },
    getAmountRemaining(row) {
      if (row.payAfter) {
        return `$${(row.payAfterMeta.amountRemaining / 100).toFixed(2)}`;
      }
      if (row.payLater) {
        if (row.isPaid) {
          return '$0';
        }
        if (row.offlinePayments && row.offlinePayments.length) {
          const amountPaid = row.offlinePayments.reduce((acc, current) => acc + (current.amount), 0);
          if (row.pricing[row.entityType].total - amountPaid > 0) {
            return `$${((row.pricing[row.entityType].total - amountPaid) / 100).toFixed(2)}`;
          }
          return '$0';
        }
        return `$${(row.pricing[row.entityType].total / 100).toFixed(2)}`;
      }
      return '$0';
    },
    async setSelectedRegoAndOpenRenewModal(rego) {
      this.selectedRego = rego;
      this.renewFrom = rego._id;
      this.isRenewing = true;
      console.log('selected rego', this.selectedRego);
      // get the products by using addToMembershipId function
      this.addToMembershipId = rego.entityId;

      // this.$nextTick(() => {
      //   this.$refs.renewMembership.openRenewModal();
      // });
      // check if the rego has a renewal option, if it does, open the renewal modal
      this.$http.get(`/assemble/api/v1/admin/registrations/${this.selectedRego._id}/renewal-options`)
        .then(async (res) => {
          this.renewingProduct = res.data.data.matchingProduct;
          this.addToMembershipProductId = this.renewingProduct._id;
          await this.handleAddToMsClicked(this.isRenewing);
        })
        .catch(() => {
          this.$message.error('Error loading renewal options');
          this.renewModalVisible = true;
        });
    },
    // openRenewModal(rego) {
    //   this.selectedRego = rego;
    //   this.$refs.renewMembership.openRenewModal();
    // },
    isRefunded(row) {
      // check the charge array, if any of the charge has refunds array length > 0, return true
      if (row.charge && row.charge.length > 0 && row.charge.some((c) => c.refunds.length > 0)) {
        return true;
      }
      return false;
    },
    getRefundAmount(row) {
      // check the charge array, if any of the charge has refunds array length > 0, return the sum of the refunds array
      // @dev - the above logic is not quite correct as a charge can have multiple (separate) registrations with possible refunds
      if (row.charge && row.charge.length > 0 && row.charge.some((c) => c.refunds.length > 0)) {
        const refundAmount = row.charge.reduce((acc, c) => {
          const refunds = c.refunds.filter((r) => r.meta.registrationId === row._id);
          return acc + refunds.reduce((a, r) => a + r.amount, 0);
        }, 0);
        // divide by 100 to get the actual amount
        return `$${(refundAmount / 100).toFixed(2)}`;
      }
      return '$0';
    },
    toggleVisibility() {
      this.showFullActions = !this.showFullActions;
    },
    priceFormatterDollar(v) {
      return v ? `$${(v).toFixed(2)}` : '$0';
    },
    startEditing(row) {
      this.editingRowId = row._id; // Assume `editingRowId` is declared in your data
    },
    finishEditing(row) {
      this.$confirm('Are you sure you want to update the expiry date?', 'Update Expiry Date', {
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(() => {
        this.$store.commit('loading', true);
        this.$http.put(`/assemble/api/v1/admin/registrations/update-expiry/${row._id}`, { expiry: row.expiry })
          .then(() => {
            this.$message.success('Expiry date updated');
          })
          .catch((err) => {
            this.$message.error(_.get(err, 'response.data.message', 'Unable to update expiry date'));
          })
          .finally(() => {
            this.$store.commit('loading', false);
          });

        this.editingRowId = null; // Reset editing ID to hide the date picker
      }).catch(() => {
        this.editingRowId = null; // Reset editing ID to hide the date picker
      });
    },
    cancelEditing(row) {
      // Reset the date picker to the original value
      const rowIndx = this.registrations.findIndex((r) => r._id === row._id);
      this.registrations[rowIndx].expiry = this.value[rowIndx].expiry;
      this.editingRowId = null; // Reset editing ID to hide the date picker
    },
    async showQRCode(rego) {
      // show qr code using dialog
      // show qr code using dialog
      if (!rego.files || rego.files.length === 0) {
        const findMsCard = await this.$http.get(`/assemble/api/v1/admin/registrations/${rego._id}/membership-card`);
        if (_.get(findMsCard, 'data.msCard.meta.qrCode')) {
          this.qrCode = findMsCard.data.msCard.meta.qrCode;
          this.showQrCodeDialog = true;
        } else {
          this.handleMsCardNotFound({ value: rego }, 'showQRCode');
        }
        return true;
      }
      const msCard = rego.files.find((file) => file.type === 'membership-card');
      if (!_.get(msCard, 'meta.qrCode')) return this.$message.error('No QR Code found');
      this.showQrCodeDialog = true;
      return this.qrCode = msCard ? msCard.meta.qrCode : '';
    },
    getExpiry(row) {
      const { expiry, expired } = row;
      if (expired) return 'Yes';
      const expiryDate = moment(expiry).format('YYYY-MM-DD');
      const today = moment().format('YYYY-MM-DD');
      if (moment(expiryDate).isBefore(today)) return 'Yes';
      return 'No';
    },
    updateCartEvent({ product, quantity }) {
      const { cart } = this;
      // eslint-disable-next-line no-underscore-dangle
      const index = cart.findIndex((item) => item.product._id === product._id);
      if (index !== -1) {
        this.cart[index].quantity = quantity;
      }
    },
    updateCartVenue(cart) {
      this.cart = cart;
    },
    getEntityName(rego) {
      const { regoEntity, meta, fromImport } = rego;
      if (!fromImport) return _.get(regoEntity, 'name');
      return meta.productName || '';
    },
    clearModal() {
      this.addToEventModalOpen = false;
      this.addToEventId = undefined;
      this.addToMembershipId = undefined;
      this.addToEventProductId = undefined;
      this.addToMembershipProductId = undefined;
      this.addToMembershipModalOpen = false;
      this.addBookingModalOpen = false;
    },
    async initialAddToEvent() {
      const memberId = this.member._id;
      const { addToEventId: eventId, addToEventProduct: product } = this;
      if (product.isMembershipRequired && product.membershipProductsRequired.length) {
        // console.log({ required: product.membershipProductsRequired.map((ms) => ms?.products?._id), registrations: this.registrations.map((r) => r.productId) });
        const checkHasRequired = await this.$http.post('/assemble/api/v1/admin/registrations/check-membership-products-required', {
          memberId,
          requiredProducts: product.membershipProductsRequired
        });
        const hasRequired = checkHasRequired.data.data;
        if (!hasRequired) {
          // eslint-disable-next-line no-param-reassign
          this.msRequiredList = product.membershipProductsRequired.map((ms) => ms.name = `${ms.name} - ${_.get(ms, 'products.memberType', '')}-${_.get(ms, 'products.gender', '')}`);
          this.requireMsDialog = true;
        } else {
          this.addToEvent();
        }
      } else {
        this.addToEvent();
      }
    },
    addToEvent() {
      const { addToEventId: eventId, addToEventProduct: product } = this;
      const { price, team } = product;
      this.$confirm(`
        Are you sure you want to assign the following product to this member?
          -
        ${this.formatProduct(product)}
      `)
        .then(() => {
          const { _id: memberId } = this.member;
          if (price === 0) {
            this.$store.commit('loading', true);
            // Add Straight Away
            this.$http.post('/assemble/api/v1/admin/add-to-event', {
              productId: product._id,
              eventId,
              memberId,
              teamId: team ? team._id : undefined
            })
              .then(((res) => {
                const newRegistration = res.data.data;
                this.registrations.push({
                  ...newRegistration,
                  team,
                });
                // this.regoKey++;
                this.$message.success('Successfully added into event');
              }))
              .catch((err) => {
                this.$message.error(_.get(err, 'response.data.message', 'Unable to pull events at the moment'));
              })
              .finally(() => {
                this.$store.commit('loading', false);
                this.clearRegoModal();
              });
          } else {
            this.$confirm('Do you want to pay now?', 'Pay Now', {
              confirmButtonText: 'Pay Now',
              cancelButtonText: 'Register Only',
              type: 'info'
            }).then(() => {
              this.$router.push({
                name: 'manual-registration',
                params: {
                  member: this.member, registrations: [product], entityType: 'event', product
                }
              });
            })
              .catch(() => {
                // Add Straight Away
                this.$store.commit('loading', true);
                this.$http.post('/assemble/api/v1/admin/add-to-event', {
                  productId: product._id,
                  eventId,
                  memberId,
                  payNow: false,
                  teamId: team ? team._id : undefined
                })
                  .then((res) => {
                    const newRegistration = res.data.data;
                    this.registrations.push({
                      ...newRegistration,
                      team,
                    });
                    // this.regoKey++;
                    this.$message.success('Successfully added into event');
                  })
                  .catch((err) => {
                    this.$message.error(_.get(err, 'response.data.message', 'Unable to pull events at the moment'));
                  })
                  .finally(() => {
                    this.$store.commit('loading', false);
                    this.clearRegoModal();
                  });
              });
          }
        })
        .catch();
    },
    // Function to split text into lines based on the maximum width
    splitTextIntoLines(ctx, text, maxWidth) {
      const words = text.split(' ');
      const lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const { width } = ctx.measureText(`${currentLine} ${word}`);

        if (width < maxWidth) {
          currentLine += ` ${word}`;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }

      lines.push(currentLine);
      return lines;
    },
    msDateFormatter(timestamp) {
      // return in this type mm/yyyy
      return moment(timestamp).tz(this.timezone).format('DD/MM/YYYY');
    },
    async generateMSCard(membershipDetails, memberProfilePics, entityPic) {
      const cardCanvas = document.createElement('canvas');
      cardCanvas.width = 500;
      cardCanvas.height = 300;
      const cardWidth = cardCanvas.width;
      const pageHeight = cardCanvas.height;
      const cardContext = cardCanvas.getContext('2d');
      const lineSpacing = 22;
      const columnSpacing = 260;
      const lineWidth = 2;
      let isLogoURL = false;
      let isProfileURL = false;
      let isEntityURL = false;

      let logoImage;
      let profileImage;
      let entityImage;
      let logoPromise; let profilePromise; let
        entityPromise;

      // Load Logo Image
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        isLogoURL = true;
      }
      if (memberProfilePics && memberProfilePics !== '' && !memberProfilePics.includes('undefined')) {
        isProfileURL = true;
      }
      if (entityPic && entityPic !== '') {
        isEntityURL = true;
      }
      if (isLogoURL) {
        const logoContent = await this.$http.post('/assemble/api/v1/admin/registrations/image-content', { logo: process.env.VUE_APP_LOGO, isURL: true });
        logoImage = new Image();
        logoImage.src = logoContent.data.data.imageContent;
        // eslint-disable-next-line no-return-assign
        logoPromise = new Promise((resolve) => logoImage.onload = resolve);
      }
      if (isProfileURL) {
        const profileContent = await this.$http.post('/assemble/api/v1/admin/registrations/image-content', { memberProfile: memberProfilePics, isURL: true });
        profileImage = new Image();
        profileImage.src = profileContent.data.data.memberImageContent;
        // eslint-disable-next-line no-return-assign
        profilePromise = new Promise((resolve) => profileImage.onload = resolve);
      }
      if (isEntityURL) {
        const entityContent = await this.$http.post('/assemble/api/v1/admin/registrations/image-content', { entityLogo: entityPic, isURL: true });
        entityImage = new Image();
        entityImage.src = entityContent.data.data.entityImageContent;
        // eslint-disable-next-line no-return-assign
        entityPromise = new Promise((resolve) => entityImage.onload = resolve);
      }

      await Promise.all([logoPromise, profilePromise, entityPromise]);

      // eslint-disable-next-line no-return-assign, no-param-reassign
      // await Promise.all([logoImage, memberProfilePics, entityPic].map((image) => new Promise((resolve) => image.onload = resolve)));

      // Draw the card background with border radius on the canvas
      cardContext.fillStyle = '#fff';
      cardContext.beginPath();
      cardContext.moveTo(20, 0);
      cardContext.lineTo(cardWidth - 20, 0);
      cardContext.quadraticCurveTo(cardWidth, 0, cardWidth, 20);
      cardContext.lineTo(cardWidth, pageHeight - 20);
      cardContext.quadraticCurveTo(cardWidth, pageHeight, cardWidth - 20, pageHeight);
      cardContext.lineTo(20, pageHeight);
      cardContext.quadraticCurveTo(0, pageHeight, 0, pageHeight - 20);
      cardContext.lineTo(0, 20);
      cardContext.quadraticCurveTo(0, 0, 20, 0);
      cardContext.closePath();
      cardContext.fill();

      // Draw the card border
      // Add border to the card
      cardContext.lineWidth = 2; // Set the border thickness
      cardContext.strokeStyle = '#000'; // Set the border color
      cardContext.stroke(); // Draw the border

      // Draw member profile logo on the top left
      const profileLogoWidth = 100;
      const profileLogoHeight = 100;
      const profileLogoX = 10;
      const profileLogoY = 10;
      cardContext.globalAlpha = 1;
      if (profileImage) {
        cardContext.drawImage(profileImage, profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      } else {
        cardContext.fillStyle = '#888';
        cardContext.fillRect(profileLogoX, profileLogoY, profileLogoWidth, profileLogoHeight);
      }

      // Draw entity logo on the top right
      const entityLogoWidth = 100;
      const entityLogoHeight = 100;
      const entityLogoX = cardWidth - entityLogoWidth - 10;
      const entityLogoY = 10;

      if (entityImage) {
        cardContext.drawImage(entityImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      } else {
        cardContext.drawImage(logoImage, entityLogoX, entityLogoY, entityLogoWidth, entityLogoHeight);
      }
      const maxLineWidth = 260; // Maximum line width in pixels for the first level text

      // Draw entity created first level limited and second level limited in the top middle
      // First level with h2-like font size and black color
      cardContext.font = 'bold 22px BrownStd-Regular';
      cardContext.fillStyle = '#000'; // Black color
      // Adjust the starting Y position for the text to be closer to the top, with a small margin
      const textStartX = profileLogoX + profileLogoWidth + 10; // Start text from the right edge of the profile photo with a 10px margin
      const entityTextY = profileLogoY + 20; // Start text 10px below the top edge of the profile logo

      // Use the splitTextIntoLines function to handle potentially long text for the first level
      const firstLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedFirstLevelLimited, maxLineWidth);
      firstLevelLines.slice(0, 2).forEach((line, index) => { // Ensure only up to 2 lines are drawn for the first level
        cardContext.fillText(line, textStartX, entityTextY + (index * 25));
      });

      // Calculate Y position for second level based on how many lines were used for first level
      const secondLevelStartY = entityTextY + (firstLevelLines.length * 25) + 5; // Adjust Y position as needed for second line, with some spacing

      // Draw entity created second level limited in gray color and normal font size, potentially split into 2 lines
      cardContext.font = '16px BrownStd-Regular'; // Normal size for second level
      cardContext.fillStyle = '#888'; // Gray color for second level

      // Use the splitTextIntoLines function for the second level as well
      const secondLevelLines = this.splitTextIntoLines(cardContext, membershipDetails.entityCreatedSecondLevelLimited, maxLineWidth);
      secondLevelLines.slice(0, 2).forEach((line, index) => { // Ensure only up to 2 lines are drawn for the second level
        cardContext.fillText(line, textStartX, secondLevelStartY + (index * 20));
      });

      // Draw membership details at the bottom
      cardContext.fillStyle = '#000';
      cardContext.font = 'bold 22px BrownStd-Regular';
      const membershipNameLines = this.splitTextIntoLines(cardContext, `${membershipDetails.membershipName}`, 450);
      membershipNameLines.forEach((line, index) => {
        cardContext.fillText(line, 10, pageHeight - 150 + index * lineSpacing);
      });
      // a line to display entity name
      // cardContext.font = '16px BrownStd-Regular';
      // cardContext.fillStyle = '#888';
      // cardContext.fillText(`${membershipDetails.entity}`, 10, pageHeight - 150 + 1 * lineSpacing); // Adjust the vertical position as needed

      // first column
      cardContext.font = '18px BrownStd-Regular';
      // membership details label, gray text color
      cardContext.fillStyle = '#aaa';
      cardContext.fillText('Membership Details', 10, pageHeight - 150 + 2 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillStyle = '#000';
      cardContext.font = '16px BrownStd-Regular';
      // cardContext.fillText(`Entity: ${membershipDetails.entity}`, 10, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member Type: ${membershipDetails.memberType}`, 10, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Season: ${membershipDetails.season}`, 10, pageHeight - 150 + 4 * lineSpacing); // Adjust the vertical position as needed
      // eslint-disable-next-line no-nested-ternary
      const expiryText = membershipDetails.deregistered || membershipDetails.expired
        ? 'Expired'
        : membershipDetails.expiry
          ? `Exp: ${this.msDateFormatter(membershipDetails.expiry)}`
          : '';
      cardContext.fillText(expiryText, 10, pageHeight - 150 + 5 * lineSpacing); // Adjust the vertical position as needed

      // Draw vertical line between columns
      cardContext.beginPath();
      cardContext.moveTo(columnSpacing - 20, pageHeight - 150 + 2 * lineSpacing);
      cardContext.lineTo(columnSpacing - 20, pageHeight - 150 + 6 * lineSpacing);
      cardContext.lineWidth = lineWidth;
      cardContext.strokeStyle = '#888';
      cardContext.stroke();

      // second column
      cardContext.font = '18px BrownStd-Regular';
      // membership details label, gray text color
      cardContext.fillStyle = '#aaa';
      cardContext.fillText('Member Details ', columnSpacing, pageHeight - 150 + 2 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillStyle = '#000';
      cardContext.font = '16px BrownStd-Regular';
      cardContext.fillText(`Name: ${membershipDetails.memberName}`, columnSpacing, pageHeight - 150 + 3 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member ID: ${membershipDetails.memberId}`, columnSpacing, pageHeight - 150 + 4 * lineSpacing); // Adjust the vertical position as needed
      cardContext.fillText(`Member Number: ${membershipDetails.memberNumber}`, columnSpacing, pageHeight - 150 + 5 * lineSpacing); // Adjust the vertical position as needed
      const dobFormat = +process.env.VUE_APP_NATIONAL_ID === 15 ? 'YYYY' : 'DD/MM/YYYY';
      cardContext.fillText(`${dobFormat === 'YYYY' ? 'Year of Birth' : 'DOB'}: ${moment(membershipDetails.memberDob).format(dobFormat)}`, columnSpacing, pageHeight - 150 + 6 * lineSpacing); // Adjust the vertical position as needed

      // Reset alpha for the entity logo
      // Draw card watermark (background image)
      cardContext.globalAlpha = 0.1;
      cardContext.drawImage(logoImage, 0, 0, cardWidth, pageHeight);
      cardContext.globalAlpha = 1;

      // create a new image object
      return new Promise((resolve) => {
        cardCanvas.toBlob((blob) => {
          resolve(blob);
        }, 'image/png');
      });
    },
    async initialAddToMembership(isRenewing = false) {
      const memberId = this.member._id;

      const currentSeason = this.$store.getters['season/currentSeason'];
      const { addToMembershipId: membershipId, addToMembershipProduct: product } = this;
      // if role is lower than super admin, then check if the member has a club membership
      if (product.isClubMembership && this.clearance > 2) {
        // find in current registrations list to check if there already a club membership
        const clubMembership = this.registrations.find((rego) => rego.isClubMembership && rego.season >= currentSeason - 2 && rego.memberType === 'player');
        if (clubMembership) {
          if (clubMembership.productId === product._id) {
            this.$message.error('Member already has a club membership');
            return;
          }
          this.checkRequestClearances(clubMembership.memberId);
          return;
        }
      }
      if (product.isMembershipRequired && product.membershipProductsRequired.length) {
        // eslint-disable-next-line no-param-reassign
        const checkHasRequired = await this.$http.post('/assemble/api/v1/admin/registrations/check-membership-products-required', {
          memberId,
          requiredProducts: product.membershipProductsRequired
        });
        const hasRequired = checkHasRequired.data.data;
        if (!hasRequired) {
          // eslint-disable-next-line no-param-reassign
          this.msRequiredList = product.membershipProductsRequired.map((ms) => ms.name = `${ms.name} - ${_.get(ms, 'products.memberType', '')}-${_.get(ms, 'products.gender', '')}`);
          this.requireMsDialog = true;
        } else {
          this.addToMembership(isRenewing);
        }
      } else {
        this.addToMembership(isRenewing);
      }
    },
    async checkRequestClearances(memberId) {
      const { entityId } = this.addToMembershipProduct;
      const response = await this.$http.get(`/assemble/api/v1/admin/club/${entityId}/member/${memberId}/regoclearances`);
      const [result] = response.data.data;
      if (result) {
        this.memberClearanceRequest = result;
        if (this.memberClearanceRequest.status === 'Approved') {
          this.addToMembership();
        }
        this.clearanceDialogVisible = true;
      } else {
        this.clearanceDialogVisible = true;
      }
    },
    handleRequestClearances() {
      const { _id, entityId, memberType } = this.addToMembershipProduct;
      _.assign(this.clearanceRequest, {
        _id,
        entityId,
        memberId: this.member._id,
        memberType
      });
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post('/assemble/api/v1/admin/regoclearances', this.clearanceRequest)
        .then(() => {
          this.$store.commit('loading', false);
          this.$message.success('Request submitted successfully');
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
      this.clearanceDialogVisible = false;
      this.clearanceDeclinedDialogVisible = false;
    },
    cancelFamilyRego() {
      this.addMembersDialog = false;
      this.familyMSList = [];
      this.familymembers = [];
    },
    initRegoFamily(fms) {
      const { addToMembershipId: membershipId, addToMembershipProduct: product } = this;
      const { price, team } = product;
      if (price === 0) {
        this.$store.commit('loading', true);
        // Add Straight Away
        this.$http.post('/assemble/api/v1/admin/add-to-family-membership', {
          productId: product._id,
          membershipId,
          fms,
          isRenewing: this.isRenewing,
          renewFrom: this.renewFrom,
        })
          .then((() => {
            // this.regoKey++;
            this.$message.success('Successfully added into membership');
            this.cancelFamilyRego();
          }))
          .catch((err) => {
            this.$message.error(_.get(err, 'response.data.message', 'Unable to pull memberships at the moment'));
          })
          .finally(() => {
            this.$store.commit('loading', false);
            this.clearRegoModal();
            this.cancelFamilyRego();
          });
      } else {
        this.$confirm('Do you want to pay now?', 'Pay Now', {
          confirmButtonText: 'Pay Now',
          cancelButtonText: 'Register Only',
          type: 'info'
        }).then(() => {
          this.$router.push({
            name: 'manual-registration',
            params: {
              member: this.member, isRenewing: this.isRenewing, renewFrom: this.renewFrom, registrations: [product], familyMSList: fms
            }
          });
        })
          .catch(() => {
            // Add Straight Away
            this.$store.commit('loading', true);
            this.$http.post('/assemble/api/v1/admin/add-to-family-membership', {
              productId: product._id,
              membershipId,
              fms,
              payNow: false,
            })
              .then((res) => {
                this.registrations = this.registrations.concat(res.data.data);
                // this.regoKey++;
                this.$message.success('Successfully added into membership');
              })
              .catch((err) => {
                this.$message.error(_.get(err, 'response.data.message', 'Unable to pull memberships at the moment'));
              })
              .finally(() => {
                this.$store.commit('loading', false);
                this.clearRegoModal();
              });
          });
      }
    },
    async handleAddToMsClicked(isRenewing = false) {
      const { addToMembershipId: membershipId, addToMembershipProduct: product } = this;
      console.log('product to add to ms', product);

      const familyMSList = _.get(product, 'products[0].familyMS', []);
      if (product.productType === 'indv') {
        this.initialAddToMembership(isRenewing);
      } else {
        this.addMembersDialog = true;
        const memberPoolRes = await this.$http.get(`/assemble/api/v1/admin/member/family/member-pool/${this.member._id}`);
        this.familymembers = [this.member, ...memberPoolRes.data.members];
        if (this.familymembers && this.familymembers.length > 0) {
          this.familyMSList = familyMSList;
          _.forEach(this.familyMSList, (fms) => {
            // eslint-disable-next-line no-param-reassign
            fms.availableMembers = this.getAvailableMembers(fms, product);
          });
        }
        console.log('familyMSList', familyMSList);
        const { memberIds } = this.renewingProduct;
        console.log('memberIds', memberIds);

        // Helper function to check if a member is eligible for a product
        const isEligibleForProduct = (member, fmsProduct) => {
          const endOfYear = this.$store.getters['national/endOfYear'];
          const age = calculateMemberAge(member.profile.dob, endOfYear);
          const isAgeEligible = age >= fmsProduct.ageFrom && age <= fmsProduct.ageTo;
          const isGenderEligible = fmsProduct.gender === member.profile.gender
        || fmsProduct.gender === 'All'
        || !fmsProduct.gender
        || (fmsProduct.gender === 'Other'
          && (member.profile.gender !== 'Male' && member.profile.gender !== 'Female'));

          return isAgeEligible && isGenderEligible;
        };

        // Get all members and their eligible products
        const memberDetails = this.familymembers.filter((m) => memberIds.includes(m._id));
        const eligibilityMap = new Map(); // Map of memberId -> array of eligible product indices

        // Build eligibility map
        memberDetails.forEach((member) => {
          const eligibleProducts = this.familyMSList.map((fmsProduct, index) => ({
            index,
            isEligible: isEligibleForProduct(member, fmsProduct)
          }))
            .filter((p) => p.isEligible)
            .map((p) => p.index);

          eligibilityMap.set(member._id, eligibleProducts);
        });

        console.log('Eligibility map:', eligibilityMap);

        const assignedMemberIds = new Set();
        const assignedProducts = new Set();

        // First, assign members who are only eligible for one product
        this.familyMSList.forEach((fmsProduct, productIndex) => {
          // Find members who are ONLY eligible for this product
          const exclusiveMembers = Array.from(eligibilityMap.entries())
            .filter(([memberId, eligibleProducts]) => !assignedMemberIds.has(memberId)
          && eligibleProducts.length === 1
          && eligibleProducts[0] === productIndex);

          if (exclusiveMembers.length > 0) {
            const [memberId] = exclusiveMembers[0];
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = memberId;
            assignedMemberIds.add(memberId);
            assignedProducts.add(productIndex);
          }
        });

        // Then, assign remaining products based on available members with fewest options
        this.familyMSList.forEach((fmsProduct, productIndex) => {
          if (assignedProducts.has(productIndex)) return;

          // Get all eligible members for this product who haven't been assigned
          const eligibleMembers = Array.from(eligibilityMap.entries())
            .filter(([memberId, eligibleProducts]) => !assignedMemberIds.has(memberId)
          && eligibleProducts.includes(productIndex))
          // Sort by number of eligible products (fewer options first)
            .sort((a, b) => a[1].length - b[1].length);

          if (eligibleMembers.length > 0) {
            const [memberId] = eligibleMembers[0];
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = memberId;
            assignedMemberIds.add(memberId);
            assignedProducts.add(productIndex);
            this.isRenewing = true;
          } else {
            // eslint-disable-next-line no-param-reassign
            fmsProduct.memberId = undefined;
          }
        });

        console.log('Final assignments:', this.familyMSList.map((p) => ({
          productIndex: this.familyMSList.indexOf(p),
          memberId: p.memberId
        })));
      }
    },
    getAvailableMembers(product, mainProduct) {
      const members = _.filter(this.familymembers, (member) => {
        const endOfYear = this.$store.getters['national/endOfYear'];

        const memberAge = calculateMemberAge(member.profile.dob, endOfYear);

        return (memberAge >= product.ageFrom && memberAge <= product.ageTo) && (product.gender === member.profile.gender || product.gender === 'All' || (product.gender === 'Other' && (member.profile.gender !== 'Male' || member.profile.gender !== 'Female')));
      });

      // required memberships
      const requiredMSProducts = _.map(mainProduct.membershipProductsRequired, (ms) => ms.products._id);

      const mappedMembers = [];

      if (requiredMSProducts && requiredMSProducts.length) {
        _.forEach(members, (member) => {
          const mappedProductId = _.map(member.registration, (rego) => rego.productId);
          const intersection = _.intersection(requiredMSProducts, mappedProductId);
          if (intersection.length === requiredMSProducts.length) mappedMembers.push(member);
        });
      }
      return _.get(mainProduct, 'isMembershipRequired') ? mappedMembers : members;
    },
    async addToMembership(renewing = false) {
      const isRenewing = typeof renewing === 'boolean' ? renewing : false;
      const { addToMembershipId: membershipId, addToMembershipProduct: product } = this;
      const { price, team } = product;
      this.$confirm(`
        Are you sure you want to assign the following product to this member?
          -
        ${this.formatProduct(product)}
      `)
        .then(async () => {
          const { _id: memberId } = this.member;
          const season = this.$store.getters['season/currentSeason'];
          const membership = this.memberships.find((m) => m._id === membershipId);
          const { orgtree } = membership;
          // Manually create an array in the desired order from lowest to highest
          const orderedOrgtree = [
            orgtree.club, // Start with the lowest level
            orgtree.association,
            orgtree.state,
            orgtree.national
          ].filter((org) => org !== undefined); // This will remove any undefined levels, in case some levels do not exist

          const entityCreatedFirstLevel = orderedOrgtree[0] ? orderedOrgtree[0].name : '';
          const entityCreatedSecondLevel = orderedOrgtree[1] ? orderedOrgtree[1].name : '';
          const entityCreatedFirstLevelLimited = entityCreatedFirstLevel.length > 67 ? `${entityCreatedFirstLevel.substring(0, 67)}...` : entityCreatedFirstLevel;
          const entityCreatedSecondLevelLimited = entityCreatedSecondLevel.length > 77 ? `${entityCreatedSecondLevel.substring(0, 77)}...` : entityCreatedSecondLevel;
          const getExpiryDate = () => {
            if (product.useDuration) {
              return moment()
                .add(product.durationYear, 'year')
                .add(product.durationMonth, 'month')
                .add(product.durationDay, 'day')
                .valueOf();
            }
            return _.get(product, 'endDate') || _.get(product, 'expiry');
          };
          const membershipDetails = {
            membershipName: membership.name,
            membershipId: membership._id,
            memberType: product.memberType,
            season,
            expiry: getExpiryDate(),
            memberName: `${this.member.profile.firstName} ${this.member.profile.lastName}`,
            memberId: this.member._id,
            memberDob: this.member.profile.dob,
            memberNumber: _.get(this.member, 'meta.memberNumber', ''),
            entityCreatedFirstLevelLimited,
            entityCreatedSecondLevelLimited,
          };
          const currMemberProfilePic = _.get(this.member, 'meta.imgUrl');
          const entityPic = _.get(membership, 'meta.imgUrl');

          const card = await this.generateMSCard(membershipDetails, currMemberProfilePic, entityPic);
          // get presigned url
          const presignedUrl = await this.$http.post('/assemble/api/v1/admin/membership-card/presigned-url', { fileName: `membership-card-${membershipDetails.memberId}-${membershipDetails.membershipId}-${product._id}.png` });
          const { url, s3Path } = presignedUrl.data.data;
          // this.$store.commit('loading', false);

          try {
            await fetch(url, {
              method: 'PUT',
              body: card,
              headers: { 'Content-Type': '*/*' },
            });
          } catch (error) {
            console.error('Failed to upload card:', error);
            // Handle the error or failure case here. For example, you might log the error or notify the user.
            // The flow will continue after this block.
          }
          if (price === 0) {
            this.$store.commit('loading', true);
            // Add Straight Away
            this.$http.post('/assemble/api/v1/admin/add-to-membership', {
              productId: product._id,
              membershipId,
              memberId,
              membershipCard: s3Path,
              teamId: team ? team._id : undefined,
              isRenewing,
              renewFrom: isRenewing ? this.renewFrom : undefined
            })
              .then(((res) => {
                this.registrations = this.registrations.concat(res.data.data);
                // this.regoKey++;
                this.$message.success('Successfully added into membership');
              }))
              .catch((err) => {
                this.$message.error(_.get(err, 'response.data.message', 'Unable to pull memberships at the moment'));
              })
              .finally(() => {
                this.$store.commit('loading', false);
                this.clearRegoModal();
              });
          } else {
            this.$confirm('Do you want to pay now?', 'Pay Now', {
              confirmButtonText: 'Pay Now',
              cancelButtonText: 'Register Only',
              type: 'info'
            }).then(() => {
              this.$router.push({
                name: 'manual-registration',
                params: {
                  member: this.member, registrations: [product], isRenewing, renewFrom: isRenewing ? this.renewFrom : undefined
                }
              });
            })
              .catch(() => {
                // Add Straight Away
                this.$store.commit('loading', true);
                this.$http.post('/assemble/api/v1/admin/add-to-membership', {
                  productId: product._id,
                  membershipId,
                  memberId,
                  payNow: false,
                  membershipCard: s3Path,
                  teamId: team ? team._id : undefined,
                  isRenewing,
                  renewFrom: isRenewing ? this.renewFrom : undefined
                })
                  .then((res) => {
                    this.registrations = this.registrations.concat(res.data.data);
                    // this.regoKey++;
                    this.$message.success('Successfully added into membership');
                  })
                  .catch((err) => {
                    this.$message.error(_.get(err, 'response.data.message', 'Unable to pull events at the moment'));
                  })
                  .finally(() => {
                    this.$store.commit('loading', false);
                    this.clearRegoModal();
                  });
              });
          }
        })
        .catch();
    },
    addBooking() {
      // const { addToMembershipId: membershipId, addToMembershipProduct: product } = this;
      // const { price, team } = product;
      const { cart } = this;
      const currentCart = cart.filter((item) => item.quantity !== 0);

      if (currentCart.length === 0) {
        this.$message.error('Please add at least one product to cart');
        return;
      }
      const slotArr = currentCart.map((item) => ({
        slotId: item.product._id,
        quantity: item.quantity,
        price: item.product.price,
        effectiveDate: item.product.effectiveDate,
        discounts: _.get(item, 'product.discounts'),
        multipleBookingDiscounts: _.get(item, 'product.multipleBookingDiscounts'),
        customForm: [],
      }));

      // this.$message.error('Test Booking');
      // return;

      // eslint-disable-next-line no-unreachable
      const cartArr = {
        entityType: currentCart[0].product.entityType,
        entityId: currentCart[0].product.entityId,
        slots: slotArr,
      };

      const booker = {
        name: `${this.member.profile.firstName} ${this.member.profile.lastName}`,
        email: this.member.profile.email,
        ...this.member.profile.address
      };

      this.$confirm('Are you sure you want to add this booking?')
        .then(() => {
          this.$confirm('Do you want to pay now?', 'Pay Now', {
            confirmButtonText: 'Pay Now',
            cancelButtonText: 'Booking Only',
            type: 'info'
          }).then(() => {
            this.$router.push({ name: 'manual-registration', params: { member: this.member, booker, registrations: [cartArr] } });
          })
            .catch(() => {
              // Add Straight Away
              this.$store.commit('loading', true);
              this.$http.post('/assemble/api/v1/admin/bookings', {
                booking: cartArr,
                booker,
                payNow: false,
              })
                .then((res) => {
                  // this.regoKey++;
                  this.$message.success('Successfully added into booking');
                })
                .catch((err) => {
                  this.$message.error(_.get(err, 'response.data.message', 'Unable to pull bookings at the moment'));
                })
                .finally(() => {
                  this.$store.commit('loading', false);
                  this.clearRegoModal();
                });
            });
        })
        .catch();
    },
    parsePrice(price) {
      return `$${(price / 100).toFixed(2)}`;
    },
    handleMakePaid() {
      // call the endpoint to mark the registration as paid
      this.$http.put(`/assemble/api/v1/admin/registrations/${this.refundRow._id}/mark-paid`, {
        paid: this.refundRow.isPaid
      })
        .then(() => {
          if (this.refundRow.isPaid) {
            this.$message.success('Registration marked as paid');
          } else {
            this.$message.warning('Registration marked as unpaid');
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
    getOnlinePaid() {
      const row = this.refundRow;
      if (row.payLater) {
        return 0;
      }
      if (row.payAfter) {
        return row.payAfterMeta.amountPaid;
      }
      // const regoTotal = row.pricing[row.entityType].total;

      // Now include the full amount including transaction fees
      const regoTotal = row.purchase.price;
      const netAmount = this.charges.reduce((acc, current) => {
        const transactionFee = _.get(current, 'meta.transactionFee');
        let currentNetAmount;
        if (!transactionFee) {
          const transactionFeePercentage = this.transactionFee();
          currentNetAmount = current.amount / (1 + transactionFeePercentage / 100);
        } else {
          currentNetAmount = current.amount - transactionFee;
        }
        return acc + currentNetAmount;
      }, 0);
      return netAmount > regoTotal ? regoTotal : netAmount;

      // return totalAmount;
    },
    getOnlineRefunded() {
      if (!this.charges.length) return 0;
      // each charge contain an refunds array
      const refunds = this.charges.reduce((acc, current) => acc.concat(current.refunds), []);
      return refunds.reduce((acc, current) => acc + current.amount, 0);
    },
    getBase64Logo() {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = `${ this.logo }?r=${ Math.floor(Math.random() * 100000)}`;
      });
    },
    getTotalWithTransactionFee(total) {
      // If a national has product transaction fee setting, apply it to product
      const preference = this.$store.getters['national/paymentPreference'];
      const { addToProduct } = preference;
      if (!addToProduct) return total;
      return +(total * ((100 + addToProduct) / 100)).toFixed();
    },
    clearRegoModal() {
      this.addToEventId = undefined;
      this.addToEventProduct = undefined;
      this.addToEventModalOpen = false;
      this.addToMembershipModalOpen = false;
      this.addBookingModalOpen = false;
    },
    formatProduct(p) {
      const tags = p.tags.length > 0 ? `(${p.tags.map((tag) => tag.name).join(', ')})` : '';
      const formatType = (type) => {
        switch (type) {
          case 'indv':
            return 'Individual';
          case 'indv-to-team':
            return 'Individual To Team';
          default: return 'Product';
        }
      };
      const {
        productType: type,
        productName,
        price,
        memberType,
        team,
      } = p;
      const name = productName ? ` (${productName})` : '';
      if (type !== 'indv-to-team') {
        return `${formatType(type)} - ${_.capitalize(memberType)} ${tags}${name} - $${(parseInt(this.getTotalWithTransactionFee(price)) / 100).toFixed(2)}`;
      }
      return `${formatType(type)} (${_.get(team, 'name', 'undefined')})- ${_.capitalize(memberType)} ${tags}${name} - $${(parseInt(this.getTotalWithTransactionFee(price)) / 100).toFixed(2)}`;
    },
    formatProductType(p) {
      switch (p) {
        case 'indv':
          return 'Individual';
        case 'indv-to-team':
          return 'Individual To Team';
        case 'team':
          return 'Team';
        case 'family':
          return 'Family';
        default:
          return '';
      }
    },
    filterEntityName(e) {
      return `${e.name}${e.entityType ? ` (${e.orgtree[e.entityType].name})` : ''}`;
    },
    earliestProcess(v) {
      return moment(v).add(3, 'days').format('YYYY-MM-DD');
    },
    refundStatusClass(v) {
      if (v === 'succeeded') return 'success-text';
      if (v === 'failed') return 'danger-text';
      return 'warning-text';
    },
    amountPaid(r) {
      const { meta, amount } = r;
      const { transactionFee } = meta;
      const total = (amount || 0) - (transactionFee || 0);
      // const { transfers } = r;
      // const transfersArr = transfers.filter((t) => t.meta.registrationId === this.editingRowId);
      // const total = transfersArr.reduce((acc, current) => (current && (current.originalAmount || current.amount)
      //   ? acc + (current.originalAmount ? current.originalAmount : current.amount)
      //   : acc
      // ), 0);
      // console.log({ transactionFee, amount });
      // console.log('transfers:', r);
      // console.log('amount paid:', total);
      return total ? `$${(total / 100).toFixed(2)}` : '$0';
    },
    partialAllowed(r) {
      if (r.type === 'offline') return false;
      const { transfers } = r;
      // let isMultiDisbursement = false;
      if (transfers.length > 1) {
        const regoType = r.meta.registrationIds && r.meta.registrationIds.length ? 'registrationId' : 'teamRegistrationId';
        const regoArr = transfers.filter((c) => c.meta[regoType] === this.refundRow._id);
        if (regoArr.length > 1) {
          const uniqEntities = _.uniqBy(regoArr, 'entityType');
          if (uniqEntities.length > 1) {
            return false;
          }
        }
      }
      return true;
    },
    amountRefunded(r) {
      const { refunds } = r;
      const total = refunds.reduce((acc, current) => (current && current.amount && current.status === 'succeeded'
        ? acc + current.amount
        : acc
      ), 0);
      return total ? `$${(total / 100).toFixed(2)}` : '$0';
    },
    amountRefundable(r) {
      if (r.type === 'offline') return 0;
      const {
        refunds, transfers
      } = r;
      if (!transfers.length) return 0;
      const transfersArr = transfers.filter((t) => t.meta.saleableItemsPurchaseId === this.editingRowId);
      const maximum = transfersArr.reduce((acc, current) => (current && (current.originalAmount || current.amount)
        ? acc + (current.originalAmount ? current.originalAmount : current.amount)
        : acc
      ), 0);
      const refunded = refunds.reduce((acc, current) => (current && current.amount && current.status === 'succeeded'
        ? acc + current.amount
        : acc
      ), 0);
      const total = (maximum - refunded) / 100;
      return total;
    },
    priceFormatter(v) {
      return v ? `$${(v / 100).toFixed(2)}` : '$0';
    },
    deregister() {
      this.$confirm('This action will de-register the member from the selected entity and cannot be undone. Continue?')
        .then(() => {
          const {
            _id,
            memberId,
            regoEntity: { name: entityName },
          } = this.deregisteringRow;
          const index = this.registrations.findIndex((rego) => rego._id === _id && rego.memberId === memberId);

          this.deregisterDialogVisible = false;
          this.$store.commit('loading', true);
          this.$http.post(`/assemble/api/v1/admin/registrations/${_id}/member/${memberId}/deregister`,
            {
              entityName,
            })
            .then(() => {
              this.$message({
                type: 'success',
                message: 'Deregistration completed'
              });
              this.$set(this.registrations, index, { ...this.registrations[index], expired: true, deregistered: true });
            })
            .catch((error) => {
              this.$message.error(error.response.data.message);
            })
            .finally(() => {
              this.$store.commit('loading', false);
            });
        })
        .catch();
    },
    initiateRefund(row) {
      // console.log({
      //   row
      // });
      this.editingRowId = row.purchase._id;
      this.$store.commit('loading', true);
      this.$http.get(`/assemble/api/v1/admin/refunds/saleable-items/${row.purchase._id}/charges`)
        .then((res) => {
          this.charges = res.data.data;
          this.refundRow = row;
          this.refundModalVisible = true;
          // console.log({
          //   charges: this.charges,
          //   refundRow: this.refundRow,
          //   refundModalVisible: this.refundModalVisible
          // });
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });
    },
    transactionFee() {
      const defaultFee = +this.$store.getters['national/transactionFee'];
      const preferredFee = +this.$store.getters['national/paymentPreference'].addToTotal;
      return !(preferredFee >= 0) ? defaultFee : preferredFee;
    },
    editOfflinePayment(row) {
      this.editingRowId = row._id;
      this.$store.commit('loading', true);
      this.$http.get(`/assemble/api/v1/admin/refunds/registration/${row._id}/charges`)
        .then((res) => {
          this.charges = res.data.data;
          this.refundRow = row;
          _.assign(row, { offlinePayments: row.offlinePayments || [] });
          _.assign(row, { offlineRefunds: row.offlineRefunds || [] });
          row.offlinePayments.forEach((payment) => {
            _.assign(payment, { action: 'payment' });
          });
          row.offlineRefunds.forEach((refund) => {
            _.assign(refund, { action: 'refund' });
          });
          // map the charges to have a type of 'online'
          const charges = _.cloneDeep(this.charges);
          charges.forEach((charge) => {
            const transactionFee = _.get(charge, 'meta.transactionFee');
            let netAmount;
            if (!transactionFee) {
              const transactionFeePercentage = this.transactionFee();
              netAmount = charge.amount / (1 + transactionFeePercentage / 100);
            } else {
              netAmount = charge.amount - transactionFee;
            }
            const regoTotal = row.pricing[row.entityType].total;
            if (netAmount > regoTotal) {
              netAmount = regoTotal;
            }
            charge.refunds.forEach((refund) => {
              _.assign(refund, { action: 'refund', type: 'online' });
            });
            _.assign(charge, { type: 'online', action: 'payment' });
            _.assign(charge, { amount: netAmount });
          });
          if (charges.length && !row.payLater) {
            this.payments = [...charges, ...row.offlinePayments, ...row.offlineRefunds];
          } else {
            this.payments = [...row.offlinePayments, ...row.offlineRefunds];
          }
          // sort the payments by date
          if (this.payments.length) {
            this.payments.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
          }
          this.offlinePaymentModalVisible = true;
        })
        .catch((error) => {
          console.log(error);
          // this.$message.error(error.response.data.message);
        })
        .finally(() => {
          this.$store.commit('loading', false);
        });
    },
    submitRefund(row) {
      const { refundRow } = this;
      const amountRefundable = this.amountRefundable(row);
      let { refundAmount } = row;
      const { _id } = row;
      const { _id: registrationId } = refundRow.purchase;
      this.refundLoading = true;
      if (!refundAmount || refundAmount <= 0) return this.refundLoading = false;
      if (refundAmount && refundAmount > amountRefundable) {
        this.$message({
          type: 'error',
          message: 'Refund requested exceeds amount refundable'
        });
        return this.refundLoading = false;
      }

      refundAmount = Math.round(refundAmount * 100);
      this.$http.post(
        `/assemble/api/v1/admin/refunds/charges-saleable-item/${_id}`,
        { refundAmount, purchaseId: +registrationId }
      )
        .then((res) => {
          this.refundLoading = false;
          this.refundModalVisible = false;
          // refresh the table
          // const { charge } = res.data;
          // const regoIndex = this.registrations.findIndex((r) => r._id === registrationId);
          // const chargeIndex = this.registrations[regoIndex].charge.findIndex((c) => c._id === _id);
          // this.registrations[regoIndex].charge[chargeIndex] = charge;
          if (res.data.status === 'failed') {
            this.$message({
              type: 'warning',
              message: `Refund failed - ${_.get(res.data, 'attemptHistory[0].errorMessage.data.messages[0].message', 'Pin Payment Error')}`
            });
          } else {
            this.$message({
              type: 'success',
              message: 'Refund successfully initiated'
            });
          }
          this.editingRowId = undefined;
        })
        .catch((error) => {
          this.refundLoading = false;
          this.$message.error(error.response.data.message || error.response.data.pinMessage);
        });
      return true;
    },
    getRefundable(r, c, value) {
      return value.some((v) => v.status === 'succeeded' && !r.refunds.length) ? 'No' : 'Yes';
    },
    clearManualPaymentForm() {
      this.$refs.manualPaymentForm.resetFields();
      this.addManualPaymentModalVisible = false;
    },
    clearManualRefundForm() {
      this.$refs.manualRefundForm.resetFields();
      this.addManualRefundModalVisible = false;
    },
    submitManualPayment() {
      this.$refs.manualPaymentForm.validate((valid) => {
        if (valid) {
          // Handle the form submission logic here
          this.$http.post(`/assemble/api/v1/admin/registrations/${this.refundRow._id}/offline-payment`, {
            amount: this.manualPaymentForm.amount,
            date: this.manualPaymentForm.date,
            note: this.manualPaymentForm.note
          }).then(() => {
            const payment = {
              amount: this.manualPaymentForm.amount,
              createdAt: moment(this.manualPaymentForm.date).valueOf(),
              note: this.manualPaymentForm.note,
              action: 'payment'
            };
            this.payments.push(payment);
            if (this.payments.length) {
              this.payments.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            }
            // find registration index
            const regoIndex = this.registrations.findIndex((r) => r._id === this.refundRow._id);
            // check if the offlinePayments array exists
            if (!this.registrations[regoIndex].offlinePayments) {
              this.registrations[regoIndex].offlinePayments = [];
            }
            this.registrations[regoIndex].offlinePayments.push(payment);
            this.clearManualPaymentForm();
          });
        }
      });
    },
    submitManualRefund() {
      this.$refs.manualRefundForm.validate((valid) => {
        if (valid) {
          // Handle the form submission logic here
          this.$http.post(`/assemble/api/v1/admin/registrations/${this.refundRow._id}/offline-refund`, {
            amount: this.manualRefundForm.amount,
            date: this.manualRefundForm.date,
            note: this.manualRefundForm.note
          }).then(() => {
            const refund = {
              amount: this.manualRefundForm.amount,
              createdAt: moment(this.manualRefundForm.date).valueOf(),
              note: this.manualRefundForm.note,
              action: 'refund'
            };
            this.payments.push(refund);
            this.payments.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
            // find registration index
            const regoIndex = this.registrations.findIndex((r) => r._id === this.refundRow._id);
            // check if the offlineRefunds array exists
            if (!this.registrations[regoIndex].offlineRefunds) {
              this.registrations[regoIndex].offlineRefunds = [];
            }
            this.registrations[regoIndex].offlineRefunds.push(refund);
            this.clearManualRefundForm();
          });
        }
      });
    },
    isShowableAnswer(name, questions) {
      const question = _.find(questions, (q) => (q.fieldName && _.camelCase(q.fieldName) === name));
      if (!question) return false;
      if (![1, 2].includes(question.type)) return false;
      return true;
    },
    metaFormat(value) {
      if (value && _.isArray(value)) return _.join(value, ', ');
      return value;
    },
    memberTypes(r, c, v) {
      return _.join(
        _.uniq(_.map(v, (rego) => _.capitalize(rego.memberType))),
        ', '
      );
    },
    dateFormatter(r, c, v) {
      return v ? timedate.set(v).tz(this.timezone).fDate() : '';
    },
    dayDateFormatter(r, c, v) {
      return v ? timedate.set(v).tz(this.timezone).fDate() : '';
    },
    async downloadReceipt(item) {
      let charges = [];
      try {
        const response = await this.$http.get(`/assemble/api/v1/admin/saleable-items/${item.purchase._id}/purchase-receipt`);
        charges = response.data.data;
      } catch {
        this.$message.error('An error occured while downloading receipt');
      }

      if (pdfMake.vfs === undefined) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      if (!charges.length) this.$message.success('This item did not incur any cost thus no receipt was found');

      let logo = '';
      let isURL = false;
      if (process.env.VUE_APP_LOGO && process.env.VUE_APP_LOGO !== '') {
        logo = this.logo;
        isURL = true;
      }

      const dd = await this.$http.post('/assemble/api/v1/admin/saleable-items/receipt-content', {
        member: this.member, charges, logo, isURL, type: 'member', portalURL: process.env.VUE_APP_PORTAL_URL, purchase: item
      });

      if (!isURL) {
        dd.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
        dd.data.data.images = { logo: await this.getBase64Logo() };
      }

      pdfMake.createPdf(dd.data.data).download(`${item.purchase._id}-${dd.data.chargeId}.pdf`);
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i += 1) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ab], { type: mimeString });
    },
    async getImageBase64(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/png'));
        };
        img.src = url;
      });
    },
    handleMsCardNotFound(val, action, change) {
      const { value: registration } = val;
      let msCard;
      let confirmText = 'Membership card is not available yet. Do you want to generate it now?';
      if (change) {
        confirmText = 'Membership details have been updated. Select yes to generate a new Membership Card.';
      }
      if (action === 'regenerate') {
        confirmText = 'Do you want the regenerate the Membership Card?';
      }
      this.$confirm(confirmText, 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      })
        .then(async () => {
          const currMember = this.member;
          const currentSeason = this.$store.getters['season/currentSeason'];
          const currMemberProfilePic = _.get(currMember, 'meta.imgUrl');
          const entityPic = _.get(registration, 'regoEntity.meta.imgUrl');
          const { orgtree } = registration;
          // Manually create an array in the desired order from lowest to highest
          const orderedOrgtree = [
            orgtree.club, // Start with the lowest level
            orgtree.association,
            orgtree.state,
            orgtree.national
          ].filter((org) => org !== undefined); // This will remove any undefined levels, in case some levels do not exist

          const entityCreatedFirstLevel = orderedOrgtree[0] ? orderedOrgtree[0].name : '';
          const entityCreatedSecondLevel = orderedOrgtree[1] ? orderedOrgtree[1].name : '';
          const entityCreatedFirstLevelLimited = entityCreatedFirstLevel.length > 67 ? `${entityCreatedFirstLevel.substring(0, 67)}...` : entityCreatedFirstLevel;
          const entityCreatedSecondLevelLimited = entityCreatedSecondLevel.length > 77 ? `${entityCreatedSecondLevel.substring(0, 77)}...` : entityCreatedSecondLevel;

          // Reverse the array to start from club and then move up, and take the first two entities
          // const entityCreated = orderedOrgtree.slice(0, 2).map((org) => org.name).join(', ');
          // console.log('entityCreated length', entityCreated.length);
          // const entityCreatedLimited = entityCreated.length > 45 ? `${entityCreated.substring(0, 45)}...` : entityCreated;
          const membershipDetails = {
            membershipName: registration.fromImport ? 'Legacy Membership' : registration.regoEntity.name,
            membershipId: registration.fromImport ? '0' : registration.regoEntity._id,
            expiry: _.get(registration, 'endDate') || _.get(registration, 'expiry'),
            memberType: _.capitalize(registration.memberType),
            season: currentSeason,
            memberId: registration.memberId,
            memberName: `${currMember.profile.firstName} ${currMember.profile.lastName}`,
            memberDob: currMember.profile.dob,
            memberNumber: _.get(currMember, 'meta.memberNumber', ''),
            entityCreatedFirstLevelLimited,
            entityCreatedSecondLevelLimited,
            deregistered: registration.deregistered,
            expired: registration.expired,
          };

          let { productId } = registration;

          // If productId is undefined, try to extract it from the existing file name
          if (!productId && registration.files && registration.files.length > 0 && membershipDetails.membershipId !== '0') {
            const msCardFile = registration.files.find((file) => file.type === 'membership-card' && file.meta?.registrationId === registration._id);
            if (msCardFile && msCardFile.fileName) {
              const fileNameParts = msCardFile.fileName.split('-');
              if (fileNameParts.length >= 4) {
                // eslint-disable-next-line prefer-destructuring
                productId = fileNameParts[fileNameParts.length - 1].split('.')[0];
              }
            }
          } else if (membershipDetails.membershipId === '0') {
            productId = '';
          }
          this.$store.commit('loading', true);
          msCard = await this.generateMSCard(membershipDetails, currMemberProfilePic, entityPic);
          // get presigned url
          const presignedUrl = await this.$http.post('/assemble/api/v1/admin/membership-card/presigned-url',
            {
              fileName: `membership-card-${registration.memberId}-${registration.entityId}-${productId}.png`,
              folder: 'membership-cards',
              membershipDetails,
              registrationId: registration._id,
              notFromRego: true,
              regenerating: !!change,
            });

          const { url, s3Path } = presignedUrl.data.data;
          this.$store.commit('loading', false);

          if (s3Path) {
            _.assign(registration, { membershipCard: s3Path });
          }

          await fetch(url, {
            method: 'PUT',
            body: msCard,
            headers: { 'Content-Type': '*/*' },
          });
          this.$message.success('Membership card generated successfully');
          if (action === 'showQRCode') {
            const findMsCard = await this.$http.get(`/assemble/api/v1/admin/registrations/${registration._id}/membership-card`);
            if (_.get(findMsCard, 'data.msCard.meta.qrCode')) {
              this.qrCode = findMsCard.data.msCard.meta.qrCode;
              this.showQrCodeDialog = true;
            }
          }
          if (msCard) {
            this.downloadMSCard(val, true);
          }
        })
        .catch(async () => {
          if (change) {
            await this.downloadMSCard(val, true);
          }
        });
    },
    async downloadMSCard(val, skipCheck) {
      // console.log(type);
      const { type, value: registration } = val;
      if (!(skipCheck === true)) {
        const msCardRes = await this.$http.get(`/assemble/api/v1/admin/registrations/${registration._id}/membership-card`);
        this.msCard = msCardRes.data.data;
        const msCardDetails = msCardRes.data.msCard;
        const hasMsCard = this.msCard && this.msCard !== '';
        if (!hasMsCard) {
          this.handleMsCardNotFound(val);
        }
        if (type === 'regenerate') {
          this.handleMsCardNotFound(val, 'regenerate');
        }
        if (msCardDetails) {
          // check meta field newChange
          if (msCardDetails.meta.newChange) {
            this.handleMsCardNotFound(val, 'download', msCardDetails.meta.lastChange);
            return;
          }
        }
      }
      // msCard is in base64 format already
      if (type === 'png') {
        const link = document.createElement('a');
        link.download = `${registration._id}.png`;

        // Convert to blob with base64
        const blob = this.dataURItoBlob(this.msCard);
        const blobUrl = URL.createObjectURL(blob);
        // Set the link href to the blob url
        link.href = blobUrl;
        // Append the link to the body
        document.body.appendChild(link);
        // Trigger the click event on the link
        link.click();
      } else if (type === 'pdf') {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        const dd = {
          content: [
            { image: this.msCard, width: [400], alignment: 'center' },
          ],
        };
        pdfMake.createPdf(dd).download(`${registration._id}.pdf`);
      }
    },
    getQuestion(metaName, additionalQs) {
      const found = additionalQs.find((data) => _.camelCase(data.fieldName) === metaName);
      return (found && found.question) || metaName;
      // return .question;
    },
    joinTag(vals) {
      return _.join(_.map(vals, (v) => v.name), ', ');
    },
    filterEntityType(value, row) {
      return row.entityType === value;
    },
    filterExpired(value, row) {
      const isExpired = this.getExpiry(row) === 'Yes';
      return value === isExpired;
    },
  },
  filters: {
    startCase,
    toDollar(value) {
      return `$${parseInt(value / 100).toFixed(2)}`;
    },
  },
  watch: {
    showFullActions(newVal) {
    },
    filters: {
      async handler() {
        try {
          this.$store.commit('loading', true);
          let res;
          if (this.filters.entityId && this.filters.entityType === 'event') {
            res = await this.$http.post('assemble/api/v1/admin/booking-slots/add-booking/query', this.filters);
          } else if (this.filters.entityId && this.filters.entityType === 'venue') {
            res = await this.$http.post(`/assemble/api/v1/admin/booking-slots/venues/${this.filters.entityId}`, {
              effectiveDate: {
                from: moment(this.currentDate).startOf('day').valueOf(),
                to: moment(this.currentDate).add(1, 'day').startOf('day').valueOf(),
              },
            });
          }
          if (res && res.data) {
            if (res.data.data.bookingSlots) {
              this.slotList = res.data.data.bookingSlots;
              this.key++;
            } else {
              this.slotList = res.data.data;
            }
            this.cart = this.slotList.map((product) => ({
              product,
              quantity: 0,
            }));
          }
          this.$store.commit('loading', false);
        } catch (error) {
          console.log(error);
          this.$store.commit('loading', false);
        }
      },
      deep: true
    },
    async addToEventId(id) {
      try {
        const res = await this.$http.post(`/assemble/api/v1/admin/event-products/${id}`);
        const products = res.data.data;
        const endOfYear = this.$store.getters['national/endOfYear'];
        const age = calculateMemberAge(this.member.profile.dob, endOfYear);
        const filteredProducts = products
          .filter((p) => (p.productType !== 'indv-to-team' ? true : !!p.team))
          .filter((p) => (
            (age >= p.ageFrom)
              && (age <= p.ageTo)
              && (p.productType === 'indv' || p.productType === 'indv-to-team')
              && ((p.gender && (p.gender).toLowerCase() === (this.member.profile.gender).toLowerCase()) || p.gender === 'All')));
        this.$set(this, 'products', filteredProducts);
        // check products and compare with registrations to see if the product is already registered
        const registeredProducts = this.registrations.map((r) => r.productId);
        const multipleRegoAllowed = this.$store.getters['national/multipleRegoAllowed'];
        // check in the products array and if any matches, add field registered: true
        this.products = this.products.map((p) => {
          // console.log('p:', p);
          if (multipleRegoAllowed) {
            const found = this.registrations.find((r) => r.productId === p._id && r.teamId === p.team._id);
            if (found) {
              return { ...p, registered: true };
            }
          } else {
            const found = this.registrations.find((r) => (r.productId === p._id && !r.deregistered));
            if (found) {
              return { ...p, registered: true };
            }
          }
          return p;
        });
      } catch (e) {
        console.log(e);
        this.$message.error(_.get(e, 'response.data.message', 'Unable to pull products at the moment'));
      }
    },
    async addToMembershipId(id) {
      try {
        const res = await this.$http.post(`/assemble/api/v1/admin/membership-products/${id}`);
        const memberships = res.data.data;
        const endOfYear = this.$store.getters['national/endOfYear'];
        const age = calculateMemberAge(this.member.profile.dob, endOfYear);
        const filteredProducts = memberships
          .filter((p) => p.productType === 'family'
            || ((age >= p.ageFrom)
            && (age <= p.ageTo)
            && (p.productType === 'indv')
            && ((p.gender).toLowerCase() === (this.member.profile.gender).toLowerCase() || p.gender === 'All')));

        this.$set(this, 'products', filteredProducts);
        console.log('products', this.products);
      } catch (e) {
        this.$message.error(_.get(e, 'response.data.message', 'Unable to pull products at the moment'));
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.read-only-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: #f56c6c;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.row-container {
  position: relative;
}
::v-deep .el-table td.el-table__cell {
  padding: 10px 0;
}
.general-info,
.payment-info {
  display: flex;
  flex-direction: column;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.label {
  font-weight: bold;
  color: #333;
  margin-right: 10px;
}

.value {
  color: #555;
}

.progress-container {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 10px;
}
.table-container {
  position: relative;
}

.header-toggle-icon {
  position: absolute;
   /* Adjust based on your layout */
  top: 10px; /* Adjust based on your layout */
  cursor: pointer;
  z-index: 100; /* Ensure it's above the table */
  color: $highlight;
  // border: 1px solid $highlight;
  padding: 5px; /* Adds space around the icon */
  border-radius: 50%; /* Circular border, remove if not needed */
  background-color: #FFFFFF; /* Optional: background color */
  box-shadow: 0 2px 6px rgba(0,0,0,0.1); /* Optional: adds shadow for better visibility */
  transition: transform 0.3s ease; /* Smooth transition for transform */

}

.actions-column {
  transition: all 0.3s ease-out; /* Adjust time as needed */
  background: #f0f0f0; /* Example background, replace with $highlight if defined */
  color: #333; /* Example text color, replace with $primary if defined */
}

/* Optional: Additional styling for hover effects or active states */
.actions-column:hover {
  background-color: #e0e0e0; /* Darker shade on hover */
}
.actions-column.closed {
  width: 100px; /* Example closed width */
  background: #d0d0d0; /* Different background for closed state */
}
::v-deep .el-table td.el-table__cell {
  padding: 10px 0;
}
.general-info,
.payment-info {
  display: flex;
  flex-direction: column;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  margin: 5px 0;
}

.label {
  font-weight: bold;
  color: #333;
  margin-right: 10px;
}

.value {
  color: #555;
}

.progress-container {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.total-cart {
  display: grid;
  grid-template-columns: 3fr 1fr 1fr;
  align-items: center;
  margin: 1rem 0 1rem 0;

}
.info-card {
  width: 100%;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.info-item:last-child {
  margin-bottom: 0;
}

</style>
